import Serializable from "@/core/misc/mixins/Serializable";
import Currency from "@/domains/Currencies/Currency";

import Title_ru_RU from "@/core/misc/decorators/Title_ru_RU";
import TYPES       from "@/core/services/Changelogs/types";

class Country extends Serializable {
	code: string;             // 2-символьный код ISO 3166 Alpha-2

	@Title_ru_RU('Страна', TYPES.STRING)
	name: string;             // Краткое название на русском

	@Title_ru_RU('Страна', TYPES.STRING)
	nameFull: string;         // Полное официальное наименование
	codeAlpha3: string;       // 3-символьный код ISO 3166 Alpha-3
	codeNum: number;          // Числовой код ISO 3166

	@Title_ru_RU('Валюта', TYPES.STRING)
	localCurrency: Currency;  // основная валюта расчета в стране

	public static fromServer(data: any, result = new Country()): Country {
		const country = super.fromServer(data, result);

		if (data.localCurrency) {
			country.localCurrency = Currency.fromServer(data.localCurrency);
		}

		return country;
	}
}

export default Country;
